export default "__VITE_ASSET__2aa78278__"